'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { getChannelScan } from '@/lib/api/channel-scan'
import type { ChannelScanResponse } from '@/lib/api/types/channel-scan'
import { ScanResult } from '../../scan-result'

interface Props {
  id: string
  initial: ChannelScanResponse | null
}

export function ResultContent({ id, initial }: Props) {
  const [data, setData] = useState<ChannelScanResponse | null>(initial)
  const [loading, setLoading] = useState(initial === null)

  useEffect(() => {
    if (data !== null) return
    let cancelled = false
    ;(async () => {
      const fetched = await getChannelScan(id)
      if (!cancelled) {
        setData(fetched)
        setLoading(false)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [id, data])

  if (loading) {
    return (
      <div className="text-center py-20 text-muted-foreground">
        Loading your scan...
      </div>
    )
  }

  if (!data) {
    return (
      <div className="text-center py-20">
        <h1 className="text-2xl font-bold text-foreground mb-3">
          Scan not found
        </h1>
        <p className="text-muted-foreground mb-6">
          This scan does not exist or has expired. Run a new one.
        </p>
        <Link
          href="/tools/youtube-channel-scanner"
          className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          Scan a channel
        </Link>
      </div>
    )
  }

  return <ScanResult initial={data} sharedView />
}
